import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth/auth.service';
import { AppConfigService } from '../services/app-config.service';

export const PARAMETRO_RETORNO_LOGIN = 'returnUrl';

export const authGuard: CanActivateFn = (_route, state) => {
    const auth = inject(AuthService);
    const appConfig = inject(AppConfigService);
    const router = inject(Router);
    if (!appConfig.loginObrigatorio()) return true;
    if (auth.possuiToken()) return true;
    return router.createUrlTree(['/login'], { queryParams: { [PARAMETRO_RETORNO_LOGIN]: state.url } });
};
